(function () {
  'use strict';
  var root = document.getElementById('fwt-finder');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';

  var tyreUrl = root.dataset.tyreUrl || '/collections/all-tyres';
  var wheelUrl = root.dataset.wheelUrl || '/collections/new-wheels';

  /* ---------- tabs ---------- */
  var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
  function showTab(tab, focus) {
    tabs.forEach(function (t) {
      var on = t === tab;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
      var panel = document.getElementById(t.getAttribute('aria-controls'));
      if (panel) panel.hidden = !on;
    });
    root.dataset.tab = tab.id === 'fwt-tab-wheels' ? 'wheels' : 'tyres';
    if (focus) tab.focus();
    if (root.dataset.tab === 'wheels') wheels.start();
  }
  tabs.forEach(function (t, i) {
    t.addEventListener('click', function () { showTab(t, false); });
    t.addEventListener('keydown', function (e) {
      var n = null;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') n = tabs[(i + 1) % tabs.length];
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') n = tabs[(i - 1 + tabs.length) % tabs.length];
      else if (e.key === 'Home') n = tabs[0];
      else if (e.key === 'End') n = tabs[tabs.length - 1];
      if (n) { e.preventDefault(); showTab(n, true); }
    });
  });

  function say(el, text, ok) {
    if (!el) return;
    el.textContent = text || '';
    el.classList.toggle('is-ok', !!ok);
  }

  function enterSubmits(form, submit) {
    form.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target && e.target.tagName === 'SELECT') {
        e.preventDefault();
        submit();
      }
    });
    form.addEventListener('submit', function (e) { e.preventDefault(); submit(); });
  }

  /* ---------- tyres ---------- */
  function readTyre(raw) {
    var F = window.FWTSize && window.FWTSize.read(raw);
    if (F) return { kind: F.kind === 'com' ? 'metric' : F.kind, d: F.d, w: F.w, p: F.p, r: F.r, label: F.display || F.label, handle: F.page || F.handle };
    if (window.FWTSize) return null;
    var s = String(raw || '').toUpperCase().replace(/\s+/g, '').replace(/^(LT|P)(?=\d)/, '');
    if (!s) return null;
    var m = s.match(/^(\d{2})[X*](\d{1,2}(?:\.\d{1,2})?)(?:Z?R|-|\/)?(\d{2})(?!\d)/);
    if (m && +m[1] >= 20 && +m[1] <= 45 && +m[2] >= 6 && +m[2] <= 20) {
      var w = (+m[2]).toFixed(2);
      return { kind: 'inch', d: m[1], w: w, r: m[3], label: m[1] + 'x' + w + 'R' + m[3], handle: m[1] + 'x' + w.replace('.', '-') + 'r' + m[3] };
    }
    m = s.match(/^(\d{3})\/?(\d{2})(?:Z?R|-|\/)?F?\/?(\d{2})(?!\d)/);
    if (m && +m[1] >= 115 && +m[1] <= 395) {
      return { kind: 'metric', w: m[1], p: m[2], r: m[3], label: m[1] + '/' + m[2] + 'R' + m[3], handle: m[1] + '-' + m[2] + 'r' + m[3] };
    }
    return null;
  }
  window.FWTReadTyre = readTyre;

  var tf = root.querySelector('[data-fwt-tyres]');
  if (tf) {
    var tmsg = document.getElementById('fwt-t-msg');
    var tq = document.getElementById('fwt-tq');
    var grids = Array.prototype.slice.call(tf.querySelectorAll('[data-fwt-mode]'));
    var radios = Array.prototype.slice.call(tf.querySelectorAll('input[name="fwt_mode"]'));
    function mode() { var r = tf.querySelector('input[name="fwt_mode"]:checked'); return r ? r.value : 'metric'; }
    function setMode(m) {
      radios.forEach(function (r) { r.checked = r.value === m; });
      grids.forEach(function (g) { g.hidden = g.dataset.fwtMode !== m; });
    }
    /* dropdowns list only sizes we have pages for (the size tags), van sizes with no profile included */
    (function () {
      if (!window.FWTSize) return;
      var all = window.FWTSize.list(); if (!all.length) return;
      var M = { w: {}, p: {}, r: {} }, I = { d: {}, w: {}, r: {} }, van = false;
      all.forEach(function (o) {
        if (o.kind === 'metric') { M.w[o.w] = 1; M.p[o.p] = 1; M.r[o.r] = 1; }
        else if (o.kind === 'com') { M.w[o.w] = 1; M.r[o.r] = 1; van = true; }
        else { I.d[o.d] = 1; I.w[o.w] = 1; I.r[o.r] = 1; }
      });
      function fillSel(sel, set, fmt, extra) {
        if (!sel) return;
        var keys = Object.keys(set).sort(function (a, b) { return parseFloat(a) - parseFloat(b); });
        while (sel.options.length > 1) sel.remove(1);
        keys.forEach(function (k) { sel.add(new Option(fmt(k), k)); });
        if (extra) sel.add(new Option(extra[1], extra[0]));
      }
      var g0 = tf.querySelector('[data-fwt-mode="metric"]'), g1 = tf.querySelector('[data-fwt-mode="inch"]');
      fillSel(g0.querySelector('[data-part="w"]'), M.w, String);
      fillSel(g0.querySelector('[data-part="p"]'), M.p, String, van ? ['R', 'None (van, e.g. 185R14C)'] : null);
      fillSel(g0.querySelector('[data-part="r"]'), M.r, function (k) { return k + '"'; });
      fillSel(g1.querySelector('[data-part="d"]'), I.d, function (k) { return k + '"'; });
      fillSel(g1.querySelector('[data-part="w"]'), I.w, function (k) { return k + '"'; });
      fillSel(g1.querySelector('[data-part="r"]'), I.r, function (k) { return k + '"'; });
    })();
    radios.forEach(function (r) { r.addEventListener('change', function () { setMode(mode()); say(tmsg, ''); }); });
    tf.addEventListener('change', function (e) {
      if (e.target && e.target.removeAttribute) e.target.removeAttribute('aria-invalid');
      if (e.target && e.target.tagName === 'SELECT') say(tmsg, '');
    });
    tq.addEventListener('input', function () { tq.removeAttribute('aria-invalid'); say(tmsg, ''); });

    var stag = document.getElementById('fwt-t-stag');
    var rearBox = document.getElementById('fwt-t-rear');
    var tqr = document.getElementById('fwt-tq-rear');
    function setStag(on) {
      if (!stag) return;
      stag.checked = on; stag.setAttribute('aria-expanded', on ? 'true' : 'false');
      rearBox.hidden = !on;
    }
    if (stag) {
      stag.addEventListener('change', function () { setStag(stag.checked); if (stag.checked) tqr.focus(); });
      tqr.addEventListener('input', function () { tqr.removeAttribute('aria-invalid'); say(tmsg, ''); });
      tqr.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); tf.requestSubmit ? tf.requestSubmit() : tf.dispatchEvent(new Event('submit', { cancelable: true })); } });
    }
    function rfMode() { var r = tf.querySelector('input[name="fwt_rf"]:checked'); return r ? r.value : 'any'; }
    function go(size) {
      var q = new URLSearchParams();
      if (stag && stag.checked && !tqr.value.trim()) {
        tqr.setAttribute('aria-invalid', 'true');
        say(tmsg, 'Type your rear tyre size, or untick "My rear tyres are a different size".');
        tqr.focus();
        return;
      }
      if (stag && stag.checked && tqr.value.trim()) {
        var rr = readTyre(tqr.value);
        if (!rr || rr.kind !== size.kind) {
          tqr.setAttribute('aria-invalid', 'true');
          say(tmsg, rr ? 'Front and rear sizes need to be both metric or both 4x4 inch.' : 'We could not read the rear size "' + tqr.value.trim() + '". Try 275/35R19.');
          tqr.focus();
          return;
        }
        if (rr.label !== size.label) q.set('rs', rr.label);
      }
      if (rfMode() !== 'any') q.set('rf', rfMode());
      var qs = q.toString();
      say(tmsg, 'Showing ' + size.label + (q.get('rs') ? ' + ' + q.get('rs') : '') + ' tyres...', true);
      window.location.href = tyreUrl + '/' + size.handle + (qs ? '?' + qs : '');
    }
    enterSubmits(tf, function () {
      var typed = tq.value.trim();
      if (typed) {
        var s = readTyre(typed);
        if (!s) {
          tq.setAttribute('aria-invalid', 'true');
          say(tmsg, 'We could not read "' + typed + '". Try 265/65R17 or 33x12.50R20.');
          tq.focus();
          return;
        }
        go(s);
        return;
      }
      var grid = tf.querySelector('[data-fwt-mode="' + mode() + '"]');
      var sels = Array.prototype.slice.call(grid.querySelectorAll('select'));
      var empty = sels.filter(function (x) { return !x.value; });
      if (empty.length) {
        empty.forEach(function (x) { x.setAttribute('aria-invalid', 'true'); });
        say(tmsg, mode() === 'inch' ? 'Choose tyre height, width and rim, or type your size.' : 'Choose width, profile and rim, or type your size.');
        empty[0].focus();
        return;
      }
      var v = {};
      sels.forEach(function (x) { v[x.dataset.part] = x.value; });
      var picked = readTyre(mode() === 'inch' ? v.d + 'x' + v.w + 'R' + v.r : v.p === 'R' ? v.w + 'R' + v.r + 'C' : v.w + '/' + v.p + 'R' + v.r);
      if (!picked) { say(tmsg, 'We could not find that size. Try typing it, e.g. 265/65R17.'); return; }
      go(picked);
    });

    var sp = new URLSearchParams(location.search);
    var rsP = readTyre(sp.get('rs'));
    if (rsP && stag) { setStag(true); tqr.value = rsP.label; }
    var rfP = sp.get('rf');
    if (rfP === 'yes' || rfP === 'no') { var rfr = tf.querySelector('input[name="fwt_rf"][value="' + rfP + '"]'); if (rfr) rfr.checked = true; }
    var path = decodeURIComponent(location.pathname);
    var pm = path.match(/\/(\d{3})-(\d{2})r(\d{2})(?:\/|$)/i);
    var im = path.match(/\/(\d{2})x(\d{1,2})(?:-(\d{1,2}))?r(\d{2})(?:\/|$)/i);
    if (pm) {
      setMode('metric');
      ['w', 'p', 'r'].forEach(function (k, i) { var el = grids[0].querySelector('[data-part="' + k + '"]'); if (el) el.value = pm[i + 1]; });
    } else if (im) {
      setMode('inch');
      var g = tf.querySelector('[data-fwt-mode="inch"]');
      var w = (+(im[2] + '.' + (im[3] || '0'))).toFixed(2);
      var set = { d: im[1], w: w, r: im[4] };
      Object.keys(set).forEach(function (k) { var el = g.querySelector('[data-part="' + k + '"]'); if (el) el.value = set[k]; });
    }
  }

  /* ---------- wheels ---------- */
  var wf = root.querySelector('[data-fwt-wheels]');
  var wheels = {
    started: false,
    data: null,
    start: function () {
      if (this.started || !wf) return;
      this.started = true;
      var self = this;
      var msg = document.getElementById('fwt-w-msg');
      var sels = Array.prototype.slice.call(wf.querySelectorAll('select[data-key]'));
      sels.forEach(function (s) { s.disabled = true; });
      say(msg, 'Loading wheel sizes...', true);
      if (!window.FWTWheelData) { say(msg, 'Wheel sizes could not load. Call us on (03) 9357 3411.'); return; }
      window.FWTWheelData.load(wheelUrl).then(function (products) {
        self.data = products;
        sels.forEach(function (s) { s.disabled = false; });
        var q = new URLSearchParams(location.search);
        sels.forEach(function (s) { var v = q.get(s.dataset.key); if (v) s.dataset.want = v; });
        self.refresh();
        say(msg, '');
      }).catch(function () {
        sels.forEach(function (s) { s.disabled = false; });
        say(msg, 'Wheel sizes could not load. Please refresh, or call us on (03) 9357 3411.');
      });
    },
    sel: function () {
      var o = {};
      wf.querySelectorAll('select[data-key]').forEach(function (s) { o[s.dataset.key] = s.value || s.dataset.want || ''; });
      return o;
    },
    refresh: function () {
      var D = window.FWTWheelData, sel = this.sel(), data = this.data || [];
      wf.querySelectorAll('select[data-key]').forEach(function (s) {
        var key = s.dataset.key, counts = {};
        data.forEach(function (p) {
          p.v.forEach(function (v) {
            if (!D.matches(v, sel, key)) return;
            var vals = key === 'pcd' ? v.pcd : [key === 'off' ? v.band : String(v[key])];
            vals.forEach(function (x) { if (x) counts[x] = (counts[x] || 0) + 1; });
          });
        });
        var keys = Object.keys(counts);
        if (key === 'off') keys = D.offsets.map(function (o) { return o[0]; }).filter(function (k) { return counts[k]; });
        else if (key === 'pcd') keys.sort(function (a, b) { var x = a.split('x'), y = b.split('x'); return (x[0] - y[0]) || (x[1] - y[1]); });
        else keys.sort(function (a, b) { return parseFloat(a) - parseFloat(b); });
        var cur = s.value || s.dataset.want || '';
        delete s.dataset.want;
        while (s.options.length > 1) s.remove(1);
        keys.forEach(function (k) {
          var name = k;
          if (key === 'rim') name = k + '"';
          else if (key === 'w') name = k + '" wide';
          else if (key === 'off') name = D.offsets.filter(function (o) { return o[0] === k; })[0][1];
          var op = new Option(name, k);
          s.add(op);
        });
        s.value = keys.indexOf(cur) >= 0 ? cur : '';
      });
    }
  };
  if (wf) {
    var wmsg = document.getElementById('fwt-w-msg');
    wf.addEventListener('change', function (e) {
      if (e.target.tagName !== 'SELECT') return;
      e.target.removeAttribute('aria-invalid');
      say(wmsg, '');
      wheels.refresh();
    });
    enterSubmits(wf, function () {
      if (!wheels.data) { wheels.start(); say(wmsg, 'Loading wheel sizes, one moment...', true); return; }
      var sel = wheels.sel();
      if (!sel.rim && !sel.pcd) {
        var r = document.getElementById('fwt-w-rim');
        r.setAttribute('aria-invalid', 'true');
        say(wmsg, 'Choose a rim size or a stud pattern (PCD) first.');
        r.focus();
        return;
      }
      var q = new URLSearchParams();
      q.set('view', 'fwt-wheels');
      ['rim', 'w', 'pcd', 'off'].forEach(function (k) { if (sel[k]) q.set(k, sel[k]); });
      say(wmsg, 'Finding wheels...', true);
      window.location.href = wheelUrl + '?' + q.toString();
    });
    var wtab = document.getElementById('fwt-tab-wheels');
    if (wtab) {
      wtab.addEventListener('focus', function () { wheels.start(); }, { once: true });
      wtab.addEventListener('mouseenter', function () { wheels.start(); }, { once: true });
    }
    if (root.dataset.tab === 'wheels') wheels.start();
  }
})();
